import React from 'react';

import './privacy-policy.css';

function PrivacyPolicy() {
  // const { isArabic } = useLanguage();
  console.log('PrivacyPolicy rendered')
  return (

    <div className="privacy-policy-section">
      <div className="privacy-policy-container">
        <h1>Privacy Notice – Freaks of Nature</h1>
        <div className="privacy-policy-content">
          <p className="privacy-policy-intro">
            This Privacy Notice explains how Freaks of Nature (“we”, “us”, or “our”) collects, uses, and protects your personal data when you interact with our website, events, or digital platforms.
            <br />
            We are committed to handling your data responsibly and in accordance with the Saudi Personal Data Protection Law (PDPL).
          </p>

          <div className="privacy-policy-text-section">
            <h2>1. What personal data do we collect?</h2>
            <p>Depending on how you interact with Freaks of Nature (event registration, contact forms, subscriptions, or inquiries), we may collect the following personal data:</p>
            <ul>
              <li>Full name</li>
              <li>Email address</li>
              <li>Phone number (if provided)</li>
              <li>Event-related information (such as attendance type or preferences)</li>
              <li>Any information you choose to share with us through forms or direct communication</li>
            </ul>
            <p>We only collect data that is necessary for a clear and specific purpose.</p>
          </div>

          <div className="privacy-policy-text-section">
            <h2>2. How do we collect your data?</h2>
            <p>We collect personal data directly from you when you:</p>
            <ul>
              <li>Fill out a form on our website</li>
              <li>Register for an event or experience</li>
              <li>Contact us via email or other communication channels</li>
              <li>Subscribe to updates or announcements</li>
            </ul>
          </div>

          <div className="privacy-policy-text-section">
            <h2>3. Why do we process your data? (Lawful basis)</h2>
            <p>We process your personal data for the following purposes:</p>
          </div>

          <div className="privacy-policy-text-section">
            <h2>4. Who will your data be shared with?</h2>
            <p>Your personal data may be shared with trusted third-party service providers who support Freaks of Nature in operating our website, managing events, or delivering services.</p>
            <p>All third parties are contractually bound to confidentiality and data protection obligations and may only process data for specified purposes.</p>
          </div>

          <div className="privacy-policy-text-section">
            <h2>5. How do we protect your data?</h2>
            <p>We take data protection seriously. Appropriate technical and organizational measures are in place to safeguard your personal data, including:</p>
            <ul>
              <li>Secure systems and access controls</li>
              <li>Encrypted data transmission where applicable</li>
              <li>Limited access to personal data on a need-to-know basis</li>
            </ul>
          </div>

          <div className="privacy-policy-text-section">
            <h2>6. Will your data be transferred outside the Kingdom of Saudi Arabia?</h2>
            <p>Unless explicitly stated otherwise, your personal data is processed and stored within the Kingdom of Saudi Arabia.</p>
            <p>If any cross-border transfer becomes necessary, it will be carried out in compliance with PDPL requirements.</p>
          </div>

          <div className="privacy-policy-text-section">
            <h2>7. How long will we keep your data?</h2>
            <p>We retain personal data only for as long as necessary to fulfill the purposes outlined in this notice or to comply with legal and regulatory obligations.</p>
            <p>Once no longer required, data is securely deleted or anonymized.</p>
          </div>

          <div className="privacy-policy-text-section">
            <h2>8. Your rights under the PDPL</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction of inaccurate or incomplete data</li>
              <li>Request deletion of your personal data, where applicable</li>
            </ul>
            <p>Requests will be handled in accordance with applicable laws and regulations.</p>
          </div>

          <div className="privacy-policy-text-section">
            <h2>9. Contact us</h2>
            <p>If you have any questions about this Privacy Notice or about how we process personal data, please contact us at:</p>
            <p className="privacy-policy-email">📧 <a href="mailto:hello@freaksofnature.me">hello@freaksofnature.me</a></p>
            <p>This email also serves as our point of contact for privacy-related inquiries.</p>
          </div>
        </div>
      </div>
    </div>

  );
}

export default PrivacyPolicy;
